import {
  FRAMES,
  GLAZING_OPTIONS,
  MAT_SIZES,
} from "@/utils/content/framingLabels";

export type FrameOptionsProps = {
  dimensions: {
    depth: number;
    face: number;
  };
  glass: {
    opacity: number;
    type: string;
  };
  label: string;
  matboard: {
    matBevelColor: string;
    hex: string;
    only: boolean;
    label?: string;
    ply: string;
    size: number;
    width: number;
    // Staff custom (special-order) mat over the stand-in colour (customMoulding.ts).
    custom?: import("@/utils/content/customMoulding").CustomPart | null;
  };
  backing: {
    hex: string;
    // Staff custom (special-order) float backing over the stand-in colour (customMoulding.ts).
    custom?: import("@/utils/content/customMoulding").CustomPart | null;
  };
  // Staff mount add-on: print mounted to Sintra / Dibond as the backing (frameMount.ts). null = standard.
  mount?: { type: string } | null;
  // Staff custom (special-order) moulding over a stand-in frame (customMoulding.ts). null = the frame shown.
  customMoulding?: import("@/utils/content/customMoulding").CustomMoulding | null;
  reveal: number;
  texture: {
    hex: string;
    face: string;
    preview: string;
    side: string;
  };
  type: string;
};

export const frameOptionsDefault: FrameOptionsProps = {
  dimensions: FRAMES[0].dimensions,
  glass: GLAZING_OPTIONS[0].options,
  label: FRAMES[0].label,
  matboard: {
    matBevelColor: "#ffffff",
    hex: "#EBEDEC",
    only: false,
    ply: MAT_SIZES[0],
    size: 2,
    width: 0,
  },
  backing: {
    hex: "#ffffff",
  },
  reveal: 0,
  texture: FRAMES[0].texture,
  type: "",
};
